/*
* Функция получения названия месяца, по его порядковому номеру от 0 до 11
* Принимает следующие параметры:
* i - порядковый номер месяца от 0 до 11, где 0 это Январь, а 11 - Декабрь
* shift - включено ли смещение, расчитано что смшение на 1 больше, то есть Январь не 0, а 1. По умолчанию false
* cases - в каком падеже нужно получить наименование от 0 до 5, где 0 - Именительный, а 5 Предложный падеж
* counts - В каком числе нужно получить наименование, 0 или 1, ге 0 - Единственное число, а 1 - множественное число.
* */

const GetNameMonthUser = (i,shift = false, cases = 0, counts = 0)=>{

    if(shift === true){
        i--;
    }

    let ArrayMonthName = [
            [
                ["Январь","Января","Январю","Январь","Январём","Январе"],
                ["Февраль","Февраля","Февралю","Февраль","Февралем","Феврале"],
                ["Март","Марта","Марту","Март","Мартом","Марте"],
                ["Апрель","Апреля","Апрелю","Апрель","Апрелем","Апреле"],
                ["Май","Мая","Маю","Май","Маем","Мае"],
                ["Июнь","Июня","Июню","Июнь","Июнем","Июне"],
                ["Июль","Июля","Июлю","Июль","Июлем","Июле"],
                ["Август","Авгута","Августу","Август","Августом","Августе"],
                ["Сентябрь","Сентября","Сентябрю","Сентябрь","Сентябрём","Сентябре"],
                ["Октябрь","Октября","Октябрю","Октябрь","Октябрём","Октябре"],
                ["Ноябрь","Ноября","Ноябрю","Ноябрь","Ноябрём","Ноябре"],
                ["Декабрь","Декабря","Декабрю","Декабрь","Декабрём","Декабре"],
            ],
            [
                ["Январи","Январей","Январям","Январи","Январями","Январях"],
                ["Феврали","Февралей","Февралям","Феврали","Февралями","Февралях"],
                ["Марты","Мартов","Мартам","Марты","Мартами","Мартах"],
                ["Апрели","Апрелей","Апрелям","Апрели","Апрелями","Апрелях"],
                ["Маи","Маев","Маям","Маи","Маями","Маях"],
                ["Июни","Июней","Июням","Июни","Июнями","Июнях"],
                ["Июли","Июлей","Июлям","Июли","Июлями","Июлях"],
                ["Августы","Августов","Августам","Августы","Августами","Августах"],
                ["Сентябри","Сентябрей","Сентябрям","Сентябри","Сентябрями","Сентябрях"],
                ["Октябри","Октябрей","Октябрям","Октябри","Октябрями","Октябрях"],
                ["Ноябри","Ноябрей","Ноябрям","Ноябри","Ноябрями","Ноябрей"],
                ["Декабри","Декабрей","Декабрям","Декабри","Декабрями","Декабрей"],
            ]
        ];

       return ArrayMonthName[counts][i][cases];
};

export default GetNameMonthUser;